import React, { createContext, useContext, useState, ReactNode } from 'react';
import type { SubscriptionSelection, SubscriptionContextType } from '../api/types';

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

export const useSubscriptionSelection = () => {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) throw new Error('useSubscriptionSelection must be used within a SubscriptionProvider');
  return ctx;
};

export const SubscriptionProvider = ({ children }: { children: ReactNode }) => {
  const [selection, setSelection] = useState<SubscriptionSelection | null>(null);
  return (
    <SubscriptionContext.Provider value={{ selection, setSelection }}>
      {children}
    </SubscriptionContext.Provider>
  );
};
